import React, { useState, useEffect, useRef } from "react";
import { toast } from "react-toastify";
import   DatePicker  from "react-datepicker";
import "../styles/styles.scss";
import axios_instance from "store/constant/axiosInstance";
import swal from "sweetalert";

const LeaderboardExportModal = ({
  isVisible,
  setFilterString,
  setExportModalVisible,
  data_type
}) => {
  const [date, setDate] = useState(null);
  const [isExporting, setIsExporting] = useState(false);
  const modalRef = useRef(null);

  const modalStyle = {
    position: "fixed",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "423px",
    zIndex: 1001,
  };

  const handleExport = async () => {
    if (data_type !== "leaders" && !date) {
      toast.error("Please select a date.");
      return;
    }

    setIsExporting(true);


    let query = `data_type=${data_type}`;
    if (data_type !== "leaders" && date) {
      const formattedDate = date.toISOString().split('T')[0];
      query += `&exact_date=${formattedDate}`;
    }
    

    if (setFilterString && typeof setFilterString === 'string' && setFilterString.trim() !== '') {
      query = `${query}&${setFilterString}`;
    }


    try {
      const response = await axios_instance.get(`leaderboard/admin/export${query.length > 0 ? `?${query}` : ""}`);


      setIsExporting(false);

      if (response.status === 200) {
        console.log("Exported data:", response.data);

        swal({
          title: "Success",
          text: "Data exported successfully!",
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "btn btn-success btn-block",
              closeModal: true,
            },
          },
          icon: "success",
        });
        setExportModalVisible(false);

      } else if (response.status === 204) {
        swal({
          title: "Information",
          text: "No data to export",
          buttons: {
            confirm: {
              text: "OK",
              value: true,
              visible: true,
              className: "btn btn-info btn-block",
              closeModal: true,
            },
          },
          icon: "info",
        });
        setExportModalVisible(false);
      } else {
        swal({
          title: "Error",
          text: `Unexpected status code: ${response.status}`,
           buttons: {
            confirm: {
              text: "Try Again",
              value: true,
              visible: true,
              className: "btn btn-danger btn-block",
              closeModal: true,
            },
          },
          icon: "error",
        });
      }

    } catch (error) {
      setIsExporting(false);
      console.error("Export Error:", error);

      let errorMessage = "Failed to export data.";
      if (error.response) {
        errorMessage = error.response.data?.message || `Server error: ${error.response.status}`;
      } else if (error.request) {
        errorMessage = "No response from server.";
      } else {
        errorMessage = error.message;
      }
      swal({
        title: "Error",
        text: errorMessage,
        buttons: {
          confirm: {
            text: "OK",
            value: true,
            visible: true,
            className: "btn btn-danger btn-block",
            closeModal: true,
          },
        },
        icon: "error",
      });
    }
  };

  useEffect(() => {
    if (!isVisible) {
      setIsExporting(false);
    }
  }, [isVisible]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        modalRef.current &&
        !modalRef.current.contains(event.target) &&
        !event.target.closest('.react-select__container') &&
        !event.target.closest('.react-select__menu') &&
        !event.target.closest('.datepicker-container')
      ) {
        setExportModalVisible(false);
      }
    };

    if (isVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isVisible, setExportModalVisible]);

  if (!isVisible) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
        }}
      />
      <div className="filter-modal" style={modalStyle} ref={modalRef}>
        <div className="filter-modal-content">
          <h6>Export Data</h6>
          <div className="filter-section">
            <div className="filter-group">
              {data_type === "leaders" ? (
                <div style={{ margin: "20px 0", fontWeight: 500 }}>
                  Proceed to export PLs and DPLs
                </div>
              ) : (
                <>
                  <label>Get Data as at:</label>
                  <div className="score-range-container calendar-input">
                    <DatePicker 
                      selected={date} 
                      placeholder="Date"
                      className="export-calendar"
                      onChange={(selectedDate) => setDate(selectedDate)}
                    />
                  </div>
                </>
              )}
            </div>
          </div>
          <div className="filter-section">
            <div className="filter-group">
              <div className="score-range-container">
                <button className="reset-filter" onClick={() => setExportModalVisible(false)}>
                  Cancel
                </button>
                <button
                  className="show-results-button"
                  disabled={isExporting || (data_type !== "leaders" && !date)}
                  onClick={handleExport}
                >
                  {isExporting ? (
                    <span
                      role="status"
                      aria-hidden="true"
                      className="spinner-border spinner-border-sm ms-2"
                    ></span>
                  ) : (
                    "Export"
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LeaderboardExportModal;
